import { render, staticRenderFns } from "./stockManage.vue?vue&type=template&id=0475bb06&scoped=true&"
import script from "./stockManage.vue?vue&type=script&lang=js&"
export * from "./stockManage.vue?vue&type=script&lang=js&"
import style0 from "./stockManage.vue?vue&type=style&index=0&id=0475bb06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0475bb06",
  null
  
)

export default component.exports